// Run this Angular example by adding the following HTML markup to your view:
//
// <%= javascript_pack_tag 'angular-engine' %>

console.log('Loading Angular Engine');

require('../angular-engine/main');
